var emitter = require('../base/emitter'),
	common = require('../base/common'),
	SliderText = require('../components/slider-text'),
	SliderImage = require('../components/slider-image');

function Navigator(){

	var self = this;
	TweenLite.set(window, {scrollTo:{y:0.2}});

	$(window).on('hashchange statechange popstate', function(e) {
		self.loadPage(location.href);
	})

	$(document).on('click', 'nav a:not(.js-lang), .header-menu_logo, [data-link]', function(e){
		e.preventDefault();

		if($(this).attr('href') == 'javascript:;' || $(this).attr('href').trim() == '') return;

		var $a = $(this);
		self.loadPage($a.attr('href'));

		if(!$a.hasClass('header-menu_logo')){
			$('nav a').removeClass('active');
			$a.addClass('active');
		}

	})

	self.checkPage();

}

Navigator.prototype.loadPage = function(href){

	var self = this;

	emitter.emit('loader:show');
	emitter.emit('page:leave');

	setTimeout(function(){
		$.get(href, function(html){

		    history.pushState({obj:href}, '', href);

			//var $html = $('<div>' + html + '</div>');
            var doc = document.implementation.createHTMLDocument('ajax');
            doc.documentElement.innerHTML = html;
			TweenLite.set(window, {scrollTo:{y:0}});
			$('#main').html(doc.getElementById('main').innerHTML);
            //console.log(doc.getElementById('main').innerHTML);
			$('body').attr('class', '');

			self.checkPage();

			emitter.emit('loader:load');
			emitter.emit('header:hide');

		});
	},500)

}

Navigator.prototype.addEvents = function(){

	var self = this;

	$('[data-move]').on('DOMMouseScroll mousewheel', _.debounce(function(e){
	    $(this).trigger('movestart', e.originalEvent.wheelDelta > 0 || e.originalEvent.detail < 0 ? 'up' : 'down');
	}, 50, { 'leading': true, 'trailing': false }));

	$('[data-move]').on('DOMMouseScroll mousewheel', function(e) {
	    $(this).trigger('move', e.originalEvent.wheelDelta > 0 || e.originalEvent.detail < 0 ? 'up' : 'down')
	})
	$('[data-move]').on('DOMMouseScroll mousewheel', _.debounce(function(e){
	    $(this).trigger('moveend', e.originalEvent.wheelDelta > 0 || e.originalEvent.detail < 0 ? 'up' : 'down');
	}, 150));

	$('.c-slider-text').each(function(){
		new SliderText($(this));
	})

}

Navigator.prototype.checkPage = function(){

	var self = this;
	if($('#block-home').length){
		emitter.emit('home:init');
	}else if($('#linee-cover').length){
		emitter.emit('linee:init');
	}else if($('#gmap').length){
		emitter.emit('contacts:init');
	}

	if($('.c-slider-image--cs').length){
		new SliderImage($('.c-slider-image--cs'));
	}

	self.addEvents();
}

module.exports = Navigator;


/** WEBPACK FOOTER **
 ** ./layouts/navigator.js
 **/